import { PureComponent } from 'react';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectContentSnapshot } from '../selectors';

class ErrorsSummaryIcon extends PureComponent {
  static propTypes = {
    snapshot: ImmutablePropTypes.map,
  };

  render() {
    const { snapshot } = this.props;
    const errors = snapshot?.get('errors');
    if (!errors || !errors.size) {
      return null;
    }
    return (
      <label className='label label-warning ml-2.5' htmlFor={undefined}>
        {errors.size}
      </label>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  snapshot: makeSelectContentSnapshot(),
});

export default connect(mapStateToProps)(ErrorsSummaryIcon);
